import { useMemo } from 'react';
import 'baseui/tabs-motion';
import 'react/jsx-runtime';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { mergeOverrides } from '../../overrides.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getTabsOverrideStyle = (element) => ({ $theme }) => {
  switch (element) {
    case "TabHighlight":
      return {
        zIndex: -1,
        height: "3px",
        backgroundColor: $theme.colors["borders-brand-primary"],
        transitionTimingFunction: $theme.animation.timingFn.ease
      };
    case "TabList":
      return {
        paddingBottom: "0",
        marginBottom: "0"
      };
    case "TabBorder":
      return {
        height: "1px",
        marginTop: "-1px",
        zIndex: -2,
        backgroundColor: $theme.colors["borders-global-secondary"]
      };
    case "Root":
      return {
        marginBottom: $theme.space[16]
      };
    default:
      return {};
  }
};
const getTabOverrideStyle = (element) => ({ $theme, $isActive }) => {
  switch (element) {
    case "ArtworkContainer":
      return {};
    case "TabPanel":
      return {
        marginTop: $theme.space[16],
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
      };
    case "Tab":
    default:
      return __spreadProps(__spreadValues({}, $theme.typography.p3), {
        background: "transparent",
        position: "relative",
        whiteSpace: "nowrap",
        color: $isActive ? $theme.colors["text-brand-primary"] : $theme.colors["text-global-secondary"],
        "::before": {
          display: "block",
          content: '""',
          width: "100%",
          position: "absolute",
          bottom: 0,
          height: "1px",
          backgroundColor: $theme.colors["borders-brand-primary"],
          pointerEvents: "none",
          transformOrigin: "bottom",
          transition: `all ${$theme.animation.duration[150]}`,
          opacity: 0
        },
        ":hover": __spreadValues({
          background: "transparent",
          color: $theme.colors["text-brand-primary"]
        }, !$isActive && {
          "::before": {
            transform: "scaleY(6)",
            opacity: 1
          }
        }),
        ":focus-visible": $theme.focusOutline
      });
  }
};
const useTabsOverrides = (overrides, $style) => {
  const resolvedStyles = useResolvedStyle($style);
  return useMemo(() => mergeOverrides({
    Root: {
      style: (styleProps) => mergeStyles(getTabsOverrideStyle("Root")(styleProps), resolvedStyles)
    },
    TabBorder: {
      style: getTabsOverrideStyle("TabBorder")
    },
    TabHighlight: {
      style: getTabsOverrideStyle("TabHighlight")
    },
    TabList: {
      style: getTabsOverrideStyle("TabList")
    },
    EndEnhancerContainer: {
      style: getTabsOverrideStyle("EndEnhancerContainer")
    }
  }, overrides), [overrides, resolvedStyles]);
};

export { getTabOverrideStyle, getTabsOverrideStyle, useTabsOverrides };
